import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  TextField,
} from "@mui/material";

//Material Icons
import { Add } from "@mui/icons-material";

//Helpers
import { selectProductImage } from "../../Helpers/productSelector";
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import Selector from "../basics/Selector";
import ModalWindow from "../Modal";

export default function RegisterAssembly({ getData, products = [] }) {
  // ==========> Component States <==========
  //State for the selected product to quote
  const [productToAdd, setProductToAdd] = useState(0);
  //State for tags
  const [tags, setTags] = useState("");
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  const productsToDisplay = products.map((p) => p.productName);

  // ==========> Component Functions <==========
  //Function to add new comment
  const newAssembly = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/assembly/new-assembly",
        {
          productName: productsToDisplay[productToAdd],
          tag: tags,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("Ensamblaje registrado.");
        setModalDescription(
          `Se ha registrado el producto ensamblado correctamente.`
        );
      } else {
        setModalText("No se pudo registrar.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo registrar.");
      setModalDescription(
        "Error al registrar el producto ensamblado, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  // ==========> Component <==========
  return (
    <Card raised>
      <Grid container sx={{ padding: "10px" }} spacing={1}>
        <Grid item xs={12}>
          {typographyForSubtitles("Registrar ensamblado", "secondary")}
        </Grid>
        <Grid item xs={12}>
          <img
            src={selectProductImage(productsToDisplay[productToAdd])}
            alt={"Imagen del producto a ensamblar"}
            height="150px"
          />
        </Grid>
        <Grid item xs={12}>
          <Stack justifyContent="center" spacing={1}>
            {typographyForCustomizedFontSize(
              "Nombre del producto",
              "11.5px",
              null,
              "bold"
            )}
            <Selector
              content={productsToDisplay}
              value={productToAdd}
              handleChange={(e) => {
                setProductToAdd(e.target.value);
              }}
              width="100%"
            />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack justifyContent="center" spacing={1}>
            {typographyForCustomizedFontSize(
              "Etiquetas",
              "11.5px",
              null,
              "bold"
            )}
            <TextField
              value={tags}
              onChange={(e) => {
                setTags(e.target.value);
              }}
              width="100%"
            />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {isLoading ? (
            <CircularProgress color="secondary" />
          ) : (
            <Button
              variant="contained"
              size="small"
              color="secondary"
              sx={{ color: "white" }}
              endIcon={<Add />}
              onClick={() => {
                newAssembly();
              }}
            >
              Registrar
            </Button>
          )}
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </Card>
  );
}
